//** NEW TEMPLATE
import React, { useEffect, useState, useCallback, useRef } from "react";
import { injectIntl } from "react-intl";
import { withRouter, Link } from "react-router-dom";
import Routes from "../../Routes";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import ACTIONS from "../../actions/types";

// HOC
import NewAppHOC from "../../hoc/NewAppHOC";
import ErrorHOC from "../../hoc/ErrorHOC";

// COMPONENTS
import MainAsideNav from "../../components/navigations/MainAsideNav";
import HelperAsideNav from "../../components/navigations/HelperAsideNav";
import Main from "../../components/main/Main";
import MainNav from "../../components/navigations/MainNav";
import AlphaTable from "../../components/tables/AlphaTable";
import AnimateLayout from "../../components/layout/AnimateLayout";
import TogglePrompt from "../../components/prompt/TogglePrompt";
import Title from "../../components/text/Title";
import Message from "../../components/alerts/Message";
import Layout from "../../components/layout/Layout";
import Icon from "../../components/icons/Icon";

// TYPES
import { isObject } from "../../types/checkTypes";

// FUNCTIONS
import AJAX from "../../functions/ajax";
import ParseHTML from "../../functions/ParseHTML";
import validateData from "../../functions/validateData";

// DATA MODEL
import collectionDataModel from "../../data_model/reviewer/collection/collection";
import stageCollectionsDataModel from "../../data_model/reviewer/collection/all_collections";

function Collection({ match, intl }) {
  const isInitialMount = useRef(false);
  const _id = 4353458974568;
  const dispatch = useDispatch();

  const [counterData, setCounterData] = useState();
  const [collectionData, setCollectionData] = useState();
  const [isCounterDone, setIsCounterDone] = useState(false);
  const [tableData, setTableData] = useState();
  const [reviewStageCollections, setReviewStageCollections] = useState();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const reduxState = useSelector(state => state);

  const getMainData = () => {
    AJAX()
      .getReviewCollection(_id, reduxState, match.params.id)
      .then(res => {
        const isDataValid = validateData(
          "Reviewer > Collection > AJAX().getReviewCollection",
          res,
          collectionDataModel
        );

        if (isDataValid) {
          const data = res.data.collection;
          getMenuData(data.stage_id);

          setCollectionData(data);
          setTableData(data.cases_table);
          setIsConfirmed(data.confirmed);
          dispatch({
            type: ACTIONS.SET_PAGE_IDS,
            payload: { stage: data.stage_id, collection: data.id },
          });
          setCounterData({
            active: data.in_range == 0 ? true : false,
            end_at: data.end_at, //new Date().setSeconds(new Date().getSeconds() + 10), //
            start_at: data.start_at,
            toWhat: intl.formatMessage({ id: "end" }),
          });
        }
      });
  };

  const init = useCallback(() => {
    getMainData();
  }, [getMainData]);

  // run once on page load
  useEffect(init, []);

  // on route change
  useEffect(() => {
    if (isInitialMount.current) {
      getMainData();
    } else {
      isInitialMount.current = true;
    }
  }, [match]);

  const getMenuData = id => {
    AJAX()
      .getReviewStage(_id, reduxState, id)
      .then(res => {
        const isDataValid = validateData(
          "Reviewer > Collection > AJAX().getReviewStage",
          res,
          stageCollectionsDataModel
        );

        if (isDataValid) {
          setReviewStageCollections(res.data.stage.collections);
        }
      });
  };

  const handleConfirm = () => {
    const confirmData = collectionData.apis.toggle_c;

    AJAX()
      .patch(_id, confirmData.api.url, {})
      .then(res => {
        if (res.data.collection.confirmed) {
          setIsConfirmed(true);
        } else if (!res.data.collection.confirmed) {
          setIsConfirmed(false);
        }

        // update the menu
        getMenuData(collectionData.stage_id);
      });
  };

  const handleNavItemClick = () => {
    dispatch({ type: ACTIONS.HIDE_MAIN_MENU_ON_TOP });
  };

  const handleCounterEnd = () => {
    setIsCounterDone(true);
  };

  const isConfirmedVisible = data => {
    if (isCounterDone) return { show: false };
    if (
      data.stats &&
      data.stats.todo === 0 &&
      Object.keys(data).length === 0 &&
      data.constructor === Object
    )
      return { show: true };
    if (
      data.stats &&
      data.stats.todo === 0 &&
      !(Object.keys(data).length === 0 && data.constructor === Object)
    )
      return { show: true, showButton: true };
    if (data.stats && data.stats.todo > 0) return { show: false };
  };

  // run on unmount
  useEffect(() => {
    return () => {
      AJAX().cancelRequest(_id);
    };
  }, [_id]);

  return (
    <NewAppHOC>
      <MainAsideNav>
        {/* <AnimateLayout animate={reviewStageCollections && collectionData} addClass="__n_bs"> */}
        <div className="__n_bs">
          <Link to="/ui/reviewer/dashboard">
            <Layout flex>
              <div>
                <Icon
                  iconId="reviewCaseFull"
                  addClass="c1 __n_bi"
                  style={{ marginRight: ".7rem" }}
                />
              </div>
              <Title tagName="h1" addClass="c16" removeWeight>
                {intl.formatMessage({ id: "reviewerDashboard" })}
              </Title>
            </Layout>
          </Link>
          {collectionData && (
            <div>
              <Link to={`/ui/reviewer/stage/${collectionData.stage_id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="categoriesFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="span" removeWeight addClass="c16">
                    {collectionData.breadcrumbs.stage.title}
                  </Title>
                </Layout>
              </Link>
              <Link to={`/ui/reviewer/collection/${collectionData.id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="listFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="h1" addClass="c16">
                    {collectionData.title}
                  </Title>
                </Layout>
              </Link>

              <ParseHTML html={collectionData.description} />
            </div>
          )}
          {reviewStageCollections && (
            <MainNav
              clicked={handleNavItemClick}
              title={intl.formatMessage({ id: "collections" })}
              data={reviewStageCollections}
              linkTo={Routes.reviewerCollection().path}
              activeItem={match.params.id}
            />
          )}
        </div>
        {/* </AnimateLayout> */}
      </MainAsideNav>
      <Main counter={counterData} onCounterEnd={handleCounterEnd}>
        {/* <AnimateLayout animate={collectionData}> */}
        {collectionData && isConfirmedVisible(collectionData).show && (
          <TogglePrompt
            confirmer
            style={{ marginBottom: "2rem" }}
            title={[intl.formatMessage({ id: "congratulation" }), intl.formatMessage({ id: "collectionFinished" })]}
            msg={
              isConfirmedVisible(collectionData).showButton
                ? [intl.formatMessage({ id: "allProjectsCollectionFinished" }), intl.formatMessage({ id: "allProjectsCollectionFinished" })]
                : [intl.formatMessage({ id: "pleaseReview" }), intl.formatMessage({ id: "clickConfirm" })]
            }
            btnText={[intl.formatMessage({ id: "confirm" }), intl.formatMessage({ id: "withdraw" })]}
            hideButtons={!isConfirmedVisible(collectionData).showButton}
            view={isConfirmed}
            callback={handleConfirm}
          />
        )}

        {tableData && tableData.data.length !== 0 ? (
          <ErrorHOC crashPage>
            <AlphaTable data={tableData} dontRenderAlerter />
          </ErrorHOC>
        ) : (
          <Message msg={intl.formatMessage({ id: "noProjectsInCollection" })} />
        )}
        {/* </AnimateLayout> */}
      </Main>
      <HelperAsideNav />
    </NewAppHOC>
  );
}

export default injectIntl(withRouter(Collection));
